// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NotificationMethodsSection-warningAvatarBackground__TCypd{background-color:var(--amber-a3)}.NotificationMethodsSection-warningAvatarIcon__wY5mD{color:var(--amber-a10)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"warningAvatarBackground": "NotificationMethodsSection-warningAvatarBackground__TCypd",
	"warningAvatarIcon": "NotificationMethodsSection-warningAvatarIcon__wY5mD"
};
export default ___CSS_LOADER_EXPORT___;
